import React, { useCallback, useEffect, useReducer, useState } from 'react'
import { ReactComponent as IconFilter } from '../../assets/images/icons/icon-filter.svg'
import { ReactComponent as IconFilterClose } from '../../assets/images/icons/icon-filter-close.svg'
import FilterModal from '../../components/FilterModal/FilterModal'
import requestApi from '../../utils/request'
import { useQuery } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import TabwithStatusFilter from '../../components/TabsForProductCatalog/TabwithStatusFilter'
//#region Match Key of Comming Data from Modal
const keyData = {
    MainCategory: { name: 'name', _id: '_id' },
    subCategory: { name: 'categoryName', _id: 'categoryId' },
    selectedMaterialOptions: { name: 'name', _id: '_id' },
    selectedTypeOptions: { name: 'name', _id: '_id' },
    selectedCountryOptions: { name: 'name', _id: '_id' },
    selectedEstimatedTimeOptions: { name: 'name', _id: '_id' },
    selectedsellerId: { name: 'fullName', _id: 'sellerId' }
    // selectedWeight: { name: "", _id: "" },
}
//#endregion

const ProductCatalog = () => {
    const { register, handleSubmit } = useForm()

    const [DataLimit, setDataLimit] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [searchKeyword, setSearchKeyword] = useState('')
    const [sorting, setSorting] = useState([])

    const [Active, setActive] = useState('Active')
    const [AllFilter, setAllFilter] = useState({})

    //#region  States for Filter Modal
    const initialState = {
        MainCategory: { name: 'Select Category' },
        subCategory: { categoryName: 'Select Sub-Category' },
        selectedMaterialOptions: { name: 'Select Material' },
        selectedTypeOptions: { name: 'Select Type' },
        selectedCountryOptions: { name: 'Select Country' },
        selectedEstimatedTimeOptions: { name: 'Select Time' },
        selectedsellerId: { fullname: '' },
        selectedWeight: ''
    }

    const reducer = (state, action) => {
        switch (action.type) {
            case 'mainCategory':
                return {
                    ...state,
                    MainCategory: action.payload
                }
            case 'subCatagory':
                return {
                    ...state,
                    subCategory: action.payload
                }
            case 'material':
                return {
                    ...state,
                    selectedMaterialOptions: action.payload
                }
            case 'type':
                return {
                    ...state,
                    selectedTypeOptions: action.payload
                }
            case 'country':
                return {
                    ...state,
                    selectedCountryOptions: action.payload
                }
            case 'time':
                return {
                    ...state,
                    selectedEstimatedTimeOptions: action.payload
                }
            case 'seller':
                return {
                    ...state,
                    selectedsellerId: action.payload
                }
            case 'weight':
                return {
                    ...state,
                    selectedWeight: action.payload
                }
            case 'clear':
                return { initialState }

            case 'clearOnebyOne':
                return { ...state, [action.key]: initialState[action.key] }

            default:
                return state
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState)
    //#endregion End Filter State

    const [ShowCatalogFilterPopup, setShowCatalogFilterPopup] = useState(false)
    const handleFilterModal = () => {
        setShowCatalogFilterPopup(true)
    }

    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )

    useEffect(() => {
        setCurrentPage(1)
    }, [searchKeyword])

    const handleSearch = useCallback((e) => {
        setCurrentPage(1)
        const getData = setTimeout(() => {
            setSearchKeyword(e.target.value)
        }, 1000)
        clearInterval()
    }, [])

    //#region  Catalog Data Listing
    function catalogList({ queryKey }) {
        return requestApi
            .post(
                `catalog/list`,
                {
                    limit: queryKey[2],
                    page: queryKey[1],
                    search: queryKey[3],
                    sortKey: 'productName',
                    sortBy: queryKey[4] ? (queryKey[4]?.desc ? -1 : 1) : '',
                    status: queryKey[5],
                    mainCategoryId: queryKey[6]?._id,
                    categoryId: queryKey[7]?.categoryId,
                    materialId: queryKey[8]?._id,
                    typeId: queryKey[9]?._id,
                    countryId: queryKey[10]?._id,
                    shippingTimeId: queryKey[11]?._id,
                    sellerId: queryKey[12]?.sellerId,
                    productWeight: queryKey[13]
                },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const { data, isLoading } = useQuery({
        queryKey: [
            'catalogList',
            currentPage,
            DataLimit,
            searchKeyword,
            sorting[0],
            Active,
            ...Object.values(AllFilter)
        ],
        queryFn: catalogList
    })
    //#endregion

    //#region  Tabs Section
    const Tabdata = [
        {
            Tab_Name: 'Accepted Product',
            status: 'Active',
            count: data?.meta?.acceptedCount,
            innerData: (
                <li className="tab-body">
                    <TabwithStatusFilter
                        id="AcceptProduct Listing"
                        getpage={(e) => setCurrentPage(e)}
                        content={data?.data}
                        loading={isLoading}
                        totalcount={data?.meta?.acceptedCount}
                        searchKeyword={searchKeyword}
                        setSearchKeyword={setSearchKeyword}
                    />
                </li>
            )
        },
        {
            Tab_Name: 'Request Product',
            status: 'Pending',
            count: data?.meta?.pendingCount,
            innerData: (
                <li className="tab-body">
                    <TabwithStatusFilter
                        id="RequestProduct Listing"
                        getpage={(e) => setCurrentPage(e)}
                        content={data?.data}
                        loading={isLoading}
                        totalcount={data?.meta?.pendingCount}
                        searchKeyword={searchKeyword}
                        setSearchKeyword={setSearchKeyword}
                    />
                </li>
            )
        },
        {
            Tab_Name: 'Rejected Product',
            status: 'Decline',
            count: data?.meta?.rejectedCount,
            innerData: (
                <li className="tab-body">
                    <TabwithStatusFilter
                        id="RejectedProduct Listing"
                        getpage={(e) => setCurrentPage(e)}
                        content={data?.data}
                        loading={isLoading}
                        totalcount={data?.meta?.rejectedCount}
                        searchKeyword={searchKeyword}
                        setSearchKeyword={setSearchKeyword}
                    />
                </li>
            )
        }
    ]
    //#endregion

    //#region ClearAll States
    function ClearStates() {
        dispatch({ type: 'clear' })
        setAllFilter({})
    }
    //#endregion

    //#region ClearHandleFilterOnebyOne
    function handleClearFilterOnebyOne(stateKey) {
        setAllFilter((prevAllFilter) => {
            const updatedAllFilter = { ...prevAllFilter }
            delete updatedAllFilter[stateKey]
            return updatedAllFilter
        })

        dispatch({ type: 'clearOnebyOne', key: stateKey })
    }
    //#endregion

    return (
        <>
            <div className="Product-catalog">
                <div className="admin-card">
                    <div class="head">
                        <h2>Product Management</h2>
                        <div className="search-btn-group">
                            <div
                                className="catalog-filter"
                                onClick={handleFilterModal}
                            >
                                <IconFilter />
                                Filter
                                <span className="dots"></span>
                            </div>
                            <form action="" className="product-table-filter">
                                <input
                                    type="search"
                                    name="ProductCatalogSearch"
                                    placeholder="Search Product"
                                    {...register('ProductCatalogSearch', {
                                        onChange: (e) => {
                                            handleSearch(e)
                                        }
                                    })}
                                    className="product-table-filter"
                                />
                            </form>
                        </div>
                    </div>
                </div>

                {Object.entries(AllFilter).length >= 1 && (
                    <div className="filter-list">
                        <ul>
                            {/* From Modal Response */}
                            {Object.entries(AllFilter).map((item) => {
                                const stateKey = item[0]
                                return (
                                    item?.[1]?.[keyData[item[0]]?._id] && (
                                        <li key={item[0]}>
                                            {
                                                item?.[1]?.[
                                                    keyData[item[0]]?.name
                                                ]
                                            }
                                            <span
                                                className="close"
                                                onClick={() =>
                                                    handleClearFilterOnebyOne(
                                                        stateKey
                                                    )
                                                }
                                            >
                                                <IconFilterClose />
                                            </span>
                                        </li>
                                    )
                                )
                            })}
                        </ul>
                        <button
                            type="button"
                            className="solid-black-btn clear-btn"
                            onClick={() => ClearStates()}
                        >
                            Clear All
                        </button>
                    </div>
                )}

                <div className="admin-tab-list">
                    <ul className="site-tab-list desktop">
                        {Tabdata.map((TabdataList, i) => {
                            return (
                                <>
                                    <li key={i}>
                                        <button
                                            className={
                                                Active === TabdataList?.status
                                                    ? 'tab-btn active'
                                                    : 'tab-btn'
                                            }
                                            onClick={() =>
                                                setActive(TabdataList?.status)
                                            }
                                        >
                                            {TabdataList.Tab_Name}{' '}
                                            {TabdataList.count >= 0 && (
                                                <span>{TabdataList.count}</span>
                                            )}{' '}
                                        </button>
                                    </li>
                                </>
                            )
                        })}
                    </ul>
                </div>

                <ul className="site-tab-list mobile">
                    {Tabdata.map((TabdataList, i) => {
                        return (
                            <>
                                <li key={i}>
                                    <button
                                        className={
                                            Active === TabdataList?.status
                                                ? 'tab-btn active'
                                                : 'tab-btn'
                                        }
                                        onClick={() => {
                                            if (
                                                Active === TabdataList?.status
                                            ) {
                                                setActive(null)
                                            } else {
                                                setActive(TabdataList?.status)
                                            }
                                            // setActive(i)
                                        }}
                                    >
                                        {TabdataList.Tab_Name}{' '}
                                        {TabdataList.count && (
                                            <span>{TabdataList.count}</span>
                                        )}{' '}
                                    </button>
                                </li>
                                {Active === TabdataList?.status &&
                                    TabdataList.innerData}
                            </>
                        )
                    })}
                </ul>
            </div>
            
            <FilterModal
                ShowCatalogFilterPopup={ShowCatalogFilterPopup}
                setShowCatalogFilterPopup={setShowCatalogFilterPopup}
                filter={(e) => setAllFilter(e)}
                state={state}
                MainCategory={state.MainCategory}
                setMainCategory={(e) =>
                    dispatch({ payload: e, type: 'mainCategory' })
                }
                subCategory={state.subCategory}
                setSubCategory={(e) =>
                    dispatch({ payload: e, type: 'subCatagory' })
                }
                selectedMaterialOptions={state.selectedMaterialOptions}
                setselectedMaterialOptions={(e) => {
                    dispatch({ payload: e, type: 'material' })
                }}
                selectedTypeOptions={state.selectedTypeOptions}
                setselectedTypeOptions={(e) =>
                    dispatch({ payload: e, type: 'type' })
                }
                selectedCountryOptions={state.selectedCountryOptions}
                setselectedCountryOptions={(e) =>
                    dispatch({ payload: e, type: 'country' })
                }
                selectedEstimatedTimeOptions={
                    state.selectedEstimatedTimeOptions
                }
                setselectedEstimatedTimeOptions={(e) =>
                    dispatch({ payload: e, type: 'time' })
                }
                selectedsellerId={state.selectedsellerId}
                setselectedsellerId={(e) =>
                    dispatch({ payload: e, type: 'seller' })
                }
                selectedWeight={state.selectedWeight}
                setselectedWeight={(e) =>
                    dispatch({ payload: e, type: 'weight' })
                }
            />
        </>
    )
}

export default ProductCatalog
